import React, { useRef } from 'react'
import './sliderpre.css'
import ImageSlider from '../../../FinalOutput/Components/Slider-prewedding/ImageSlider';
import PreWeddingVideo from '../../../FinalOutput/Components/Slider-prewedding/PreWeddingVideo';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


const Sliderpre = ({details}) => {
     const sectionRef = useRef(null);
  const flowersRef = useRef([]);

        const images = details?.footerImages || [];
    const preWeddingLink = details?.preWeddingLink?.trim();

    const hasImages = images.length > 0;
    const hasPreWedding = !!preWeddingLink;

    const addFlowerRef = (element) => {
    if (element && !flowersRef.current.includes(element)) {
      flowersRef.current.push(element);
    }
  };


   useGSAP(() => {

    const flowers = flowersRef.current;

    // Section is optional / flowers may not exist
    if (!flowers.length) return;

    gsap.fromTo(
      flowers,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 1.1,
        ease: "power2.out",
        stagger: 0.08,

        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 85%",
          once: true,
        },
      }
    );

  }, {
    scope: sectionRef,
  });


   if (!hasImages && !hasPreWedding) {
    return null;
  }


  return (
     <section
            className={`t5-slider-section
                ${details?.theme || ''}`}
                  ref={sectionRef}
        >
        
        <img  src='/theme5-slider-section-asset.png' alt='section-flower'  className='theme5-slider-asset asset-top'   ref={addFlowerRef} />
          <img  src='/theme5-slider-section-asset.png' alt='section-flower' className='theme5-slider-asset  asset-right'   ref={addFlowerRef} />
            <img  src='/theme5-slider-section-asset.png' alt='section-flower' className='theme5-slider-asset  asset-bottom'   ref={addFlowerRef} />
              <img  src='/theme5-slider-section-asset.png' alt='section-flower' className='theme5-slider-asset  asset-left'    ref={addFlowerRef} />
      

        
                    <div className={`t5-slider-content   ${hasPreWedding ? 'theme5-has-prewedding': ''}  `}   >
                        {hasImages && <ImageSlider images={images} />}
                        {hasPreWedding && <PreWeddingVideo link={preWeddingLink} />}
                    </div>

        </section>
  )
}

export default Sliderpre